import { LoadingOutlined } from "@ant-design/icons";
import { Empty } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Product, Search } from "../../components";
import { getDataJacket } from "../../config/Redux/action";
import { ActionProduct } from "../../config/Redux/actionTypes";

const Jacket = () => {
  const dispatch = useDispatch();
  const product = useSelector((state) => state.product);
  const [jackets, setJackets] = useState([]);
    let dataAosIcrement = 500;

  useEffect(() => {
    const getData = async () => {
      const res = await dispatch(getDataJacket());
      setJackets(res);
    };
    getData();
  }, [dispatch]);

  const totalJacket = jackets.filter(
    (trouser) => trouser.data.publish === 'published',
  );

  const handleSearch = async (e) => {
    e.preventDefault();
    const data = await dispatch(getDataJacket());

    const search = data.filter((trouser) => {
      return Object.values(trouser.data.name)
        .join('')
        .toLowerCase()
        .includes(product.search.toLowerCase());
    });
    dispatch({ type: ActionProduct.SEARCH, value: '' });
    setJackets(search);
  };

  return (
    <div id='product-user'>
      <main>
        <section className='search'>
          <Search value={product.search} search={handleSearch} />
        </section>
        <section className='trouser'>
          <h1 data-aos='fade-right'>Produk Celana</h1>
          {product.isLoading ? (
            <LoadingOutlined className='loadingProduct' />
          ) : (
            <div
              className={totalJacket.length > 0 ? 'product-content' : 'empty'}
            >
              {totalJacket.length > 0 ? (
                jackets
                  .filter((jacket) => jacket.data.publish === 'published')
                  .map((jacket) => {
                    return (
                      <Product
                        delay={(dataAosIcrement += 200)}
                        key={jacket.id}
                        link={`detail/${jacket.id}`}
                        image={jacket.data.image_url}
                        name={jacket.data.name}
                        normalPrice={jacket.data.price}
                        discount={jacket.data.promoPrice}
                      />
                    );
                  })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
          )}
        </section>
      </main>
    </div>
  );
};

export default Jacket;